import { MutationTuple, gql, useMutation } from '@apollo/client';

const UPDATE_USER_MUTATION = gql`
  mutation updateUserByAdmin($details: ApiUpdateUserByAdmin!) {
    updateUserByAdmin(details: $details) {
      message
    }
  }
`;

interface UpdateUserInput {
  details: {
    email?: string;
    accountType?: string;
    isActive?: boolean;
  };
}

interface UpdateUserOutput {
  sendPasswordResetEmail: {
    message: string;
  };
}

function useUpdateUserByAdminMutation(): MutationTuple<
  UpdateUserOutput,
  UpdateUserInput
> {
  return useMutation<UpdateUserOutput, UpdateUserInput>(UPDATE_USER_MUTATION);
}

export type { UpdateUserOutput };
export { useUpdateUserByAdminMutation };
